var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-col", { attrs: { cols: "12" } }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 form-page" },
        [
          !_vm.additional
            ? _c("h4", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("application.messages.beginApplication")) +
                    "\n      "
                ),
              ])
            : _c("h4", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("application.listing.createAdditionalApplication")
                    ) +
                    "\n      "
                ),
              ]),
          _vm._v(" "),
          !_vm.additional
            ? _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "application.messages.applicationMethod.beginApplication"
                      )
                    ) +
                    "\n      "
                ),
              ])
            : _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "application.messages.applicationMethod.createAdditional"
                      )
                    ) +
                    "\n      "
                ),
              ]),
          _vm._v(" "),
          _vm.requestPersonalDetails
            ? _c("b-row", [
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "form-group-material" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.client.givenName,
                              expression: "client.givenName",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "first-name",
                            required: "",
                            type: "text",
                            name: "givenName",
                            placeholder: _vm.$t(
                              "application.placeholders.givenName"
                            ),
                          },
                          domProps: { value: _vm.client.givenName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.client,
                                "givenName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "title text-light-gray mb-2 mb-lg-0",
                            attrs: { for: "first-name" },
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("account.givenName"))),
                            _c("input-required-indicator"),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", { staticClass: "form-group-material" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.client.familyName,
                              expression: "client.familyName",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "last-name",
                            required: "",
                            type: "text",
                            name: "familyName",
                            placeholder: _vm.$t(
                              "application.placeholders.familyName"
                            ),
                          },
                          domProps: { value: _vm.client.familyName },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.client,
                                "familyName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "title text-light-gray mb-2 mb-lg-0",
                            attrs: { for: "last-name" },
                          },
                          [
                            _vm._v(_vm._s(_vm.$t("account.familyName"))),
                            _c("input-required-indicator"),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group-material" },
                        [
                          _c("phone-input", {
                            staticClass: "form-control",
                            attrs: {
                              id: "phone",
                              value: _vm.client.phoneNumber,
                              name: "phoneNumber",
                              placeholder: _vm.$t(
                                "application.placeholders.phoneNumber"
                              ),
                              "emit-value": true,
                            },
                            on: {
                              change: function (val) {
                                return (_vm.client.phoneNumber = val)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "title text-light-gray mb-2 mb-lg-0",
                              attrs: { for: "phone" },
                            },
                            [_vm._v(_vm._s(_vm.$t("account.phoneNumber")))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "form-group-material" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.client.email,
                                expression: "client.email",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              id: "email",
                              type: "email",
                              name: "emailNoFill",
                              pattern: "^$|^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
                              placeholder: _vm.$t(
                                "application.placeholders.email"
                              ),
                            },
                            domProps: { value: _vm.client.email },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.client,
                                  "email",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "bar" }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass: "title text-light-gray mb-2 mb-lg-0",
                              attrs: { for: "email" },
                            },
                            [_vm._v(_vm._s(_vm.$t("account.email")))]
                          ),
                          _vm._v(" "),
                          _c("section-error", {
                            attrs: { "error-message": _vm.displayErrorMessage },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "article",
            {
              staticClass: "mb-2",
              class: !_vm.requestPersonalDetails ? "mt-4" : "mt-1",
            },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("application-flow.labels.mortgageType")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row no-gutters" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "form-container fe-radio-form large-radio col-lg-12 px-0",
                  },
                  _vm._l(_vm.flowsColumns, function (option) {
                    return _c(
                      "div",
                      {
                        key: option.value,
                        staticClass: "fe-option flow-option",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.client.flow,
                              expression: "client.flow",
                            },
                          ],
                          attrs: {
                            id: "flow-" + option.value,
                            type: "radio",
                            required: "",
                            name: "flow",
                          },
                          domProps: {
                            value: option.value,
                            checked: _vm._q(_vm.client.flow, option.value),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$set(_vm.client, "flow", option.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkmark" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "flow-" + option.value } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("application-flow.flows." + option.value)
                              )
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          !_vm.requestPersonalDetails && _vm.showIncludeCoApplicants
            ? _c(
                "div",
                {
                  staticClass:
                    "pretty p-icon p-jelly p-primary p-round mr-2 mb-2",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.coApplicants,
                        expression: "coApplicants",
                      },
                    ],
                    attrs: {
                      id: "copy-co-applicants",
                      name: "copyCoApplicants",
                      type: "checkbox",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.coApplicants)
                        ? _vm._i(_vm.coApplicants, null) > -1
                        : _vm.coApplicants,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.coApplicants,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.coApplicants = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.coApplicants = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.coApplicants = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "state p-success p-primary-alt" }, [
                    _c("i", { staticClass: "icon fa fa-check" }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "clickable",
                        attrs: { for: "copy-co-applicants" },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("application.actions.copyCoappInformation")
                          )
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.requestPersonalDetails && !_vm.clientDetails.familyName
            ? _c("div", [
                _c("p", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("application.messages.lastNameMissing")) +
                      "\n        "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("article", [
            _c("div", { staticClass: "row align-items-center mb-3" }, [
              _c("div", { staticClass: "col-6" }, [
                _c("p", { staticClass: "title mb-0" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$t("application.messages.applicationLanguage")
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-6 d-flex align-items-center" },
                [
                  _c("lang-selector", {
                    attrs: {
                      "locale-model": _vm.locale,
                      "with-confirmation": false,
                    },
                    on: {
                      "update:localeModel": function ($event) {
                        _vm.locale = $event
                      },
                      "update:locale-model": function ($event) {
                        _vm.locale = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.top",
                        value: _vm.$t(
                          "application.messages.applicationLanguageDescription"
                        ),
                        expression:
                          "\n                $t('application.messages.applicationLanguageDescription')\n              ",
                        modifiers: { top: true },
                      },
                    ],
                    staticClass: "ml-2 clickable",
                    attrs: { name: "question-circle" },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-center no-gutters" }, [
            _c(
              "div",
              { staticClass: "col-6" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "white" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("hide")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("global.words.close")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-end align-items-center col-6",
              },
              [
                !_vm.additional
                  ? _c(
                      "a",
                      {
                        staticClass: "clickable back-from-option mr-3",
                        on: { click: _vm.handleClick },
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-long-arrow-left pr-2",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(
                          _vm._s(_vm.$t("global.words.back")) + "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "simple-button",
                  {
                    attrs: {
                      id: "create-application",
                      form: "begin-app-form",
                      loading: _vm.buttonIsLoading,
                      "loading-succeeded": _vm.createFailed,
                      disabled: !_vm.isValid,
                    },
                    on: { click: _vm.createApplication },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("application.actions.createApplication")
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }